import { render, staticRenderFns } from "./MemberIntegralSurvey.vue?vue&type=template&id=85a5a180&scoped=true&"
import script from "./MemberIntegralSurvey.vue?vue&type=script&lang=js&"
export * from "./MemberIntegralSurvey.vue?vue&type=script&lang=js&"
import style0 from "./MemberIntegralSurvey.vue?vue&type=style&index=0&id=85a5a180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a5a180",
  null
  
)

export default component.exports